import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import QrReader from "react-qr-scanner";
import BoltIcon from "@mui/icons-material/Bolt";
import { useTranslation } from "react-i18next";

export default function QrCodeScanner(props) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  const handleScan = (data) => {
    if (props.setQrData && data && data.text) {
      props.setQrData(data.text);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        bgcolor: "#000",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 72,
          zIndex: 2,
          bgcolor: "#F8FAFF",
          borderRadius: 7,
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <BoltIcon />
        <Typography
          color="#000"
          fontSize={14}
          fontWeight={400}
          paddingLeft={2}
          paddingRight={2}
        >
          {t("ScanQR")}
        </Typography>
      </Box>
      {error ? (
        <Typography color="#F8FAFF" textAlign="center" px={3} zIndex={2}>
          {error}
        </Typography>
      ) : (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            "& section": {
              width: "100%",
              height: "100%",
            },
            "& video": {
              width: "100% !important",
              height: "100% !important",
              objectFit: "cover",
            },
          }}
        >
          <QrReader
            delay={300}
            style={{ width: "100%", height: "100%" }}
            onError={(err) =>
              setError(
                err?.message ||
                  t("unableToAccessCamera", {
                    defaultValue: "Unable to access camera",
                  })
              )
            }
            onScan={handleScan}
            constraints={{
              audio: false,
              video: { facingMode: { ideal: "environment" } },
            }}
          />
        </Box>
      )}
      <Box
        sx={{
          position: "absolute",
          width: "16rem",
          height: "16rem",
          border: "0.2rem solid #FFF",
          borderRadius: 2,
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
    </Box>
  );
}
